import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderOpen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFolderOpen"><Path fillRule="evenodd" clipRule="evenodd" d="M10.4014 3H2V20H20.0612L23.0028 10H21V6H12.4014L10.4014 3ZM19.5 10V7.5H11.5986L9.59861 4.5H3.5V18.5H4.93882L7.43882 10H19.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderOpen;
